import React, { Component } from 'react';
import '../css_generales/getConfiguracionSucursal.css';
import GetOnlyviewUbication from './getOnlyviewUbication';
import 'whatwg-fetch';
class getVistaSucursalUbicacion extends Component {
  constructor(props){
    super(props)
    this.state = {
        id_sucursales:this.props.id_sucursal,
        lat : 0 ,
        lon : 0,
        distancia : 0,
        tipo_entorno:0,
        polygonos: []
    }
  }
  cargar_informacion_poligonos =()=>{
    const url= this.props.dir_url + "webapp/getDataInformacionSucursalpoligonos";
    const token =  this.props.token
    const id_sucursales = this.state.id_sucursales
    var obj = { accion:'datainformacionsucursalpoligonos', token,id_sucursales};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data[0].msg)
         this.setState({
           polygonos:data[0].msg
         })
      }
    })
    .catch(console.log)
  }
  cargar_informacion =()=>{
    const url= this.props.dir_url + "webapp/getDataInformacionSucursal";
    const token =  this.props.token
    const id_sucursales = this.state.id_sucursales
    var obj = { accion:'datainformacionsucursal', token,id_sucursales};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        if(Number(data[0].msg[0].tipo_entorno)===1){
          this.setState({
            lat:data[0].msg[0].lat,
            lon:data[0].msg[0].lon,
            distancia:0,
            tipo_entorno:data[0].msg[0].tipo_entorno,
          },()=>{
            this.cargar_informacion_poligonos()
          })
        }else{
          this.setState({
            lat:data[0].msg[0].lat,
            lon:data[0].msg[0].lon,
            distancia:data[0].msg[0].distancia,
            tipo_entorno:data[0].msg[0].tipo_entorno,
          })
        }
      }
    })
    .catch(console.log)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  render() {
    return(
      <React.Fragment>
      <div className="div_global_registre_U_datasucursal">
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_" style={{"color":"black"}}>Vista Previa de Ubicación GPS de la Sucursal</div>
        </div>
        <div style={{"width": "100%","height":"100%"}}>
          {((Number(this.state.lon)>0||Number(this.state.lon)<0)&&Number(this.state.distancia)>0)?
            <GetOnlyviewUbication className="pruebas" lat={this.state.lat} distancia={this.state.distancia}  zoom={15} lon={this.state.lon}/>
          :''}
          {
            (this.state.polygonos&&Number(this.state.tipo_entorno)===1)?
              <GetOnlyviewUbication className="pruebas" tipo_entorno={this.state.tipo_entorno} lat={this.state.lat} distancia={0}  zoom={14} lon={this.state.lon} polygonos={this.state.polygonos}/>
            :''
          }
        </div>
      </div>
      </React.Fragment>
    )
  }
  componentDidMount (){
    this.cargar_informacion()
  }

}
export default getVistaSucursalUbicacion;
